export const cleanedText = (text) => text.replace(/\D/g, '');
